<template>
  <v-dialog
    v-model="dialog"
    max-width="700px"
  >
    <v-form
      ref="form"
      v-model="valid"
      :lazy-validation="true"
      autocomplete="off"
    >
      <v-card>
        <v-card-title>
          <span class="headline font-weight-bold">Modifica Servizio</span>
        </v-card-title>

        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-text-field
                  v-model="editedItem.name"
                  label="Nome"
                  :rules="[rules.required]"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="editedItem.price"
                  label="Prezzo"
                  type="number"
                  :rules="[rules.required]"
                  required
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="close"
          >Cancella</v-btn>
          <v-btn
            color="primary"
            text
            @click="save"
          >Salva</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
  import axios from 'axios'
  import { mapMutations, mapGetters } from 'vuex'

  export default {
    name: 'EditForm',

    data() {
      return {
        editedItem: {},
        valid: false,
        rules: {
          required: value => !!value || 'Campo obbligatorio.',
        },
        config: {
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
          }
        },
      }
    },

    props: {
      item: { type: Object }
    },

    computed: {
      ...mapGetters([
        'getServiziEdit'
      ]),
      dialog: {
        get() {
          return this.getServiziEdit
        },
        set() {
          this.CHANGE_SERVIZI_EDIT(false)
        }
      }
    },

    methods: {
      ...mapMutations([
        'CHANGE_SERVIZI_EDIT'
      ]),

      close() {
        this.CHANGE_SERVIZI_EDIT(false)
      },

      async save() {
        if (this.$refs.form.validate()) {

          this.$emit('edit-submit', 'reset')

          const { data } = await axios.post(`${process.env.VUE_APP_API}/services/update`, this.editedItem, this.config)

          if (data.status) {

            this.$emit('edit-submit', 'ok')
            this.close()
          } else {

            this.$emit('edit-submit', 'error')
          }
        }
      }
    },

    watch: {
      dialog(val) {
        val || this.close() && this.CHANGE_SERVIZI_EDIT(false)
      },
      item(val) {
        this.editedItem = val
      }
    }
  }
</script>

<style>
</style>